
import AppContactUs from '@/components/ContactUs.vue'
import { defineComponent } from 'vue'
import { useStore } from 'vuex'
import { ActionBar, ActionBarButton } from 'vant'
export interface ThemeVars {
  borderRadiusMax: string
}
export default defineComponent({
  name: 'Device-Footer',
  components: {
    VanActionBar: ActionBar,
    VanActionBarButton: ActionBarButton,
    AppContactUs,
  },
  props: {
    isCanClick: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: '',
    },
  },
  setup() {
    const store = useStore()
    return {
      isMiniProgram: store.getters.isMiniProgram,
    }
  },
  emits: ['footerSubmit'],
  methods: {
    onClickButton(): void {
      if (!this.isCanClick) return
      this.$emit('footerSubmit')
    },
  },
})
